import { useState, useEffect } from 'react';
import 'react-tabs/style/react-tabs.css';

import moment from 'moment';
import 'moment/locale/pt-br';

import { Stack, Button } from '@mui/material';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import Input from '../../form/Input';
import InputNumber from '../../form/InputNumber';
import Checkbox from '../../form/Checkbox';
import SelectEmpresa from '../../form/SelectEmpresa';
import Select from '../../form/Select';
import DataList from '../../form/DataList';

/* funções */
import { retornaData } from '../../../utils/retornaDataFormatada';

/* utils */
import { formatarNumero, formatarNumeroDecimal } from '../../../utils/masks';
import { checarCnhHandler, obterCnhCategorias } from '../../../api/cnh';
import { formatCnhFeedback } from '../../../utils/cnhFeedback';
/* apis */
import * as DataListAPI from '../../../api/dataList';

import * as PessoaAPI from '../../../api/pessoa';
import * as ProdutoAPI from '../../../api/produto';
import * as TabelaAPI from '../../../api/tabela';

function Form({
    token,
    dados,
    setDados,
    empresaId,
    empresaIds,
    parametro,
    handleSubmit,
    btnText,
    caminhoVoltar,
    OptionsEmpresa,
}) {
    const [pessoa, setPessoa] = useState({});
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const urlParams = new URLSearchParams(window.location.search);
    const tipo = urlParams.get('tipo');

    const params = new URLSearchParams({
        ul: urlParams.get('ul'),
        li: urlParams.get('li'),
        tipo: urlParams.get('tipo'),
        operacao: urlParams.get('operacao'),
        uuid: urlParams.get('uuid'),
        btnText: urlParams.get('btnText'),
    });

    if (btnText.toLowerCase() === 'cadastrar') {
        setDados((prev) => ({
            ...prev,
            data: retornaData(moment()),
        }));
    }

    //set datalist
    const [OptionsParceiro, setOptionsParceiro] = useState([]);

    //Select
    const [OptionsMotorista, setMotorista] = useState([]);
    const [OptionsVTR, setVTR] = useState([]);

    // params => empresaId, tabela, id, descricao, condicao, filtro
    const consultaDatalist = async (params) => {
        try {
            return await DataListAPI.dataList(params);
        } catch (error) {
            console.error('Erro ao consultar DataList:', error);
            throw error;
        }
    };

    //Consultas no backend
    const consultaParceiro = async (pessoaId, empresaId) => {
        const result = await PessoaAPI.financeiro(pessoaId, empresaId);
        return result;
    };
    const consultaColaborador = async (empresaId, filtro, condicao) => {
        const result = await PessoaAPI.colaborador(empresaId, filtro, condicao);
        setMotorista(result);
        setDados((prev) => ({
            ...prev,
            //ativo: true,
            data: dados.data,
            //parceiroId: dados.parceiroId,
            valor: dados.valor,
            empresaId: dados.empresaId,
            pessoaId: dados.pessoaId ? dados.pessoaId : result[0]?.id,
        }));

        return result;
    };
    const consultaVTR = async (empresaId, ativo, filtro, condicao) => {
        if (!empresaId) return null;

        try {
            let kmAnterior = 0;
            let produtoId = null;
            let motoristaId = null;

            // Consultas do backend
            const motorista = await consultaColaborador(empresaId, null, 'motorista');

            const result = await ProdutoAPI.bem(empresaId, ativo, filtro, condicao);

            if (Array.isArray(motorista) && motorista.length > 0 && motorista[0]?.id) {
                motoristaId = dados.motoristaId ? dados.motoristaId : motorista[0].id;
            }

            if (Array.isArray(result) && result.length > 0 && result[0]?.id) {
                kmAnterior = await ProdutoAPI.ultimoKm(result[0].id);
                produtoId = dados.produtoId ? dados.produtoId : result[0].id;
            }

            //verificar se o motorista esta apto a conduzir o veiculo
            const validaCNH = await checarCnhHandler({ produtoId, pessoaId: motoristaId, data: dados.data });

            if (validaCNH.ok === false) {
                // Transforma em mensagem amigável
                const { text, severity, title, lines } = formatCnhFeedback(validaCNH);

                // Se você usa um único flash:
                setFlashMessage(text, severity);
            }
            // Atualizar o estado de VTR e usar um callback opcional para continuar
            setVTR(result);

            setDados((prev) => ({
                ...prev,

                produtoId: produtoId,
                pessoaId: motoristaId,
                kmAnterior: kmAnterior,
            }));
        } catch (error) {
            console.error('Erro ao consultar VTR:', error);
        }
    };

    useEffect(() => {
        setPessoa(dados?.Pessoa || {});
        dados.empresaId && consultaVTR(dados.empresaId, null, null, 'Móvel');

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dados.empresaId]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const vtr = await TabelaAPI.tabelaById(dados.empresaId, 'Produto', dados.produtoId);
                // Faça algo com 'vtr' se necessário
                const km = await ProdutoAPI.ultimoKm(vtr.id, dados.km);

                // Adicione o valor de km ao objeto vtr
                vtr.kmAnterior = km;
                setDados((prevDados) => ({
                    ...prevDados,
                    ativo: true,
                    data: prevDados.data,
                    parceiroId: prevDados.parceiroId,
                    pessoaId: prevDados.pessoaId,
                    valor: prevDados.valor,
                    km: prevDados.km,
                    kmAnterior: vtr.kmAnterior,
                }));
            } catch (error) {
                console.error('Erro ao buscar dados:', error);
            }
        };

        const fetchValidaCNH = async () => {
            try {
                //verificar se o motorista esta apto a conduzir o veiculo
                const validaCNH = await checarCnhHandler({
                    produtoId: dados.produtoId,
                    pessoaId: dados.pessoaId,
                    data: dados.data,
                });
                // Converte para mensagem amigável
                const { text, severity, title, lines } = formatCnhFeedback(validaCNH);
                // Mostra aviso se NÃO apto, ou se vence em < 30 dias
                if (!validaCNH.ok || validaCNH?.validade?.status === 'expiring') {
                    setFlashMessage(text, severity, 5);
                }
            } catch (error) {
                console.error(error);
                setFlashMessage('Falha ao validar CNH do condutor.', 'danger', 5);
                throw error; // se você quiser propagar para um erro global
            }
        };
        if (dados.produtoId) {
            fetchData(); // Chama a função assíncrona
        }

        if (dados.produtoId && dados.pessoaId) {
            fetchValidaCNH();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dados.produtoId, dados.pessoaId]);

    async function handleChange(e) {
        const { name, value, checked, type } = e.target;

        if (name === 'ativo') {
            setDados({ ...dados, [name]: checked });
        } else if (name.startsWith('Pessoa.')) {
            setPessoa({
                ...pessoa,
                [name.split('.')[1]]: value,
            });

            //consulta datalist
            //empresaId, tabela, id, descricao, condicao, filtro
            const data = await consultaDatalist({
                empresaId: dados.empresaId,
                tabela: 'Pessoa',
                condicao: tipo,
                filtro: value,
            });
            setOptionsParceiro(data);

            const selectedId = document.querySelector(`datalist option[value="${value}"]`)?.dataset.id;

            setDados((prevState) => ({
                ...prevState,
                parceiroId: selectedId ?? null,
            }));
        } else if (name === 'litros' || name === 'preco') {
            const valorFormatado = formatarNumeroDecimal(value);
            setDados({
                ...dados,
                [name]: valorFormatado,
            });
        } else {
            setDados({ ...dados, [name]: value });
        }
    }
    async function handleOnBlur(e) {
        const { name, value, checked, type } = e.target;
        if (name === 'preco') {
            dados.valor = parseFloat(dados.litros * dados.preco).toFixed(2);
        }
    }
    function handleOnFocus(e) {}

    const submit = (e) => {
        e.preventDefault();
        if (!dados.valor) {
            dados.valor = parseFloat(dados.litros * dados.preco).toFixed(2);
        }

        if (dados.km < dados.kmAnterior) {
            setFlashMessage('Confira as quilometragens!', 'error');
            return;
        }
        handleSubmit(dados);
    };

    return (
        <form onSubmit={submit}>
            <h1>Mapa Abastecimento</h1>
            <div>
                <Input
                    text="Data"
                    type="date"
                    name="data"
                    placeholder="Data"
                    title="Data do abastecimento"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.data}
                />
                <SelectEmpresa
                    text="Selecione a Empresa"
                    name="empresaId"
                    options={OptionsEmpresa}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.empresaId || ''}
                    required
                    notOptNull={true}
                />
                <DataList
                    text="Selecione o Parceiro"
                    name="Pessoa.nomePrincipal"
                    inputWidth="400px"
                    filteredOptions={OptionsParceiro}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={pessoa.nomePrincipal || ''}
                    required={true}
                />
            </div>
            <div>
                <Select
                    name="pessoaId"
                    title="Selecione o motorista"
                    text="Motorista"
                    inputWidth="300px"
                    options={OptionsMotorista}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.pessoaId}
                    isEnum={false}
                    notOptNull={true}
                    required={true}
                />

                <Select
                    name="produtoId"
                    title="Selecione o veículo"
                    text="Veículo"
                    inputWidth="300px"
                    options={OptionsVTR}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.produtoId}
                    isEnum={false}
                    notOptNull={true}
                    required={true}
                />
            </div>
            <div>
                <Input
                    text="Km Anterior"
                    type="number"
                    name="kmAnterior"
                    placeholder="Km"
                    inputWidth="100px"
                    title="Km anterior"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.kmAnterior || ''}
                    textAlign="center"
                    readonly={true}
                />
                <Input
                    text="Km Atual"
                    type="number"
                    name="km"
                    placeholder="Km"
                    inputWidth="100px"
                    title="Digite o km no momento do abastecimento"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.km || ''}
                    textAlign="center"
                    readonly={false}
                    required={true}
                />
                <InputNumber
                    text="Litros"
                    type="text"
                    name="litros"
                    placeholder="Litros"
                    inputWidth="150px"
                    title="digite a quantidade de litros no momento do abastecimento"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.litros ? formatarNumero(dados.litros) : ''}
                    required={true}
                />
                <InputNumber
                    text="Preço"
                    type="text"
                    name="preco"
                    placeholder="Preço R$"
                    inputWidth="150px"
                    title="digite o valor do litro"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.preco ? formatarNumero(dados.preco) : ''}
                    required={true}
                />
                <Checkbox
                    title="Ativa quando marcado"
                    text="Ativo"
                    name="ativo"
                    handleOnChange={handleChange}
                    value={dados.ativo}
                    checked={!!dados.ativo}
                />
            </div>
            <div>
                <Stack direction="row" spacing={1}>
                    <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar)}>
                        Voltar
                    </Button>
                    <Button type="submit" variant="contained" color="success">
                        {btnText}
                    </Button>
                </Stack>
            </div>
        </form>
    );
}
export default Form;
